export default __webpack_public_path__ + "static/media/parceirosImage.6201a598.jpg";